<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/subscription-account']" translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</a>
    <mat-icon>chevron_right</mat-icon>
    <span>{{ this.mng_impexp_title }}</span>
</div>

<tb-header parentPage="importExportSection"></tb-header>

<div class="contentGlobal">
    <div style="display: flex; justify-content: center; flex-wrap: wrap">
        <div>
            <mat-card class="fuse-card-grid">
                <mat-card-header>
                    <mat-card-title translate>COMMONS.SUBSCRIPTION</mat-card-title>
                </mat-card-header>
                <div class="inputSearchStyle">
                    <mat-form-field appearance="outline">
                        <mat-label translate>COMMONS.SEARCH</mat-label>
                        <mat-icon matPrefix [inline]="true">search</mat-icon>
                        <input matInput (keyup)="applyFilterSubscriptions($event)" placeholder="{{ 'COMMONS.SEARCH' | translate }}" [(ngModel)]="searchSubscription" />
                        <mat-icon matSuffix [inline]="true" (click)="clearSubscriptionSearch()" class="pointer">highlight_off</mat-icon>
                    </mat-form-field>
                </div>
                <div class="message-box info">
                    {{ 'IMPORT_EXPORT_SECTION.IF_DONT_FIND_SUB' | translate }}<br />
                    <span *ngIf="this.storeRoleService?.IsInternal">{{ 'IMPORT_EXPORT_SECTION.NO_SNAP_DESCR' | translate }}</span>
                </div>
                <table mat-table id="subscriptionsTable" [dataSource]="dataSourceSubscription" matSort style="width: 100%">
                    <ng-container matColumnDef="Description">
                        <th mat-header-cell *matHeaderCellDef class="header-cell" mat-sort-header>
                            <span translate>COMMONS.DESCRIPTION</span>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span>{{ element.Description }}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="SubscriptionKey">
                        <th mat-header-cell *matHeaderCellDef class="header-cell" mat-sort-header>
                            <span translate>EDIT_SUBSCRIPTION.SUBKEY_CODE</span>
                        </th>
                        <td mat-cell *matCellDef="let element" upperCase>{{ element.SubscriptionKey }}</td>
                    </ng-container>
                    <ng-container matColumnDef="Actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell class="text-align-right" *matCellDef="let element">
                            <div>
                                <button mat-icon-button matTooltip="{{ 'IMPORT_EXPORT_SECTION.IMP_DATA' | translate }}" matTooltipClass="tooltip-layout" (click)="setSubKeyAndGo(element, 'import')">
                                    <mat-icon><span class="material-icons-outlined">archive</span></mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="{{ 'IMPORT_EXPORT_SECTION.EXP_DATA' | translate }}" matTooltipClass="tooltip-layout" (click)="setSubKeyAndGo(element, 'export')">
                                    <mat-icon><span class="material-icons-outlined">unarchive</span></mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="{{ 'IMPORT_EXPORT_SECTION.EXP_HISTORY' | translate }}" matTooltipClass="tooltip-layout" (click)="directionsImpExpAndHist(element, 'history')">
                                    <mat-icon>grading</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsSubscriptions"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsSubscriptions"></tr>
                </table>
                <mat-paginator #subscriptionsPaginator *ngIf="hasItems" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                <span translate *ngIf="!hasItems && !loading">COMMONS.NO_ELEMENTFOUND</span>
            </mat-card>
        </div>
    </div>
    <div *ngIf="loading">
        <tb-loading></tb-loading>
    </div>
</div>
